export default __webpack_public_path__ + "static/media/register-plane.ab26380b.png";